import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import moment from 'moment';
import { Moment } from 'moment';
import { baseAbsenceLimitCalcFunc, equivalentHourlyAbsenceLimitCalcFunc } from 'src/app/common/utils/absence-utils';
import { AbsenceLimitCalcTypeEnum } from 'src/app/models/enums/absence-limit-calc-type-enum';

export const maxDateRangeValidator =
  (startDateControl: AbstractControl, endDateControl: AbstractControl, maxRange: number, areWeekendsDaysOff: boolean, daysOff: Date[], absenceLimitCalcType: AbsenceLimitCalcTypeEnum): ValidatorFn =>

    (control: AbstractControl): ValidationErrors | null => {
      let diff: number;
      const startDate: Moment = !!startDateControl?.value && moment(startDateControl?.value);
      const endDate: Moment = !!endDateControl?.value && moment(endDateControl?.value);

      if (!startDate || !endDate) {
        return null;
      }

      switch (absenceLimitCalcType) {
        case AbsenceLimitCalcTypeEnum.EquivalentHourly:
          diff = endDate.diff(startDate, 'days');
          maxRange = equivalentHourlyAbsenceLimitCalcFunc(Math.floor(maxRange) + 1) - 1;
          break;
        default:
          diff = baseAbsenceLimitCalcFunc(areWeekendsDaysOff, daysOff, diff, endDate, startDate, absenceLimitCalcType);
          break;
      }

      return maxRange < 0 || diff > maxRange + 1 ? { maxDateRangeExceeded: true } : null;
    };


